<nav class="navbar navbar-expand-lg navbar-dark bg-dark justify-content-between">
  <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{ collapse: collapsed, 'navbar-collapse': true }">

    <ul class="navbar-nav ">
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="/home">{{'home' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" >{{'services' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" >{{'gallery' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="/about">{{'about' | translate }}</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="/contact">{{'contact' | translate }}</a>
      </li>
    </ul>
  </div>
  <div class="w-25 text-center">
    <span class="form-inline">
      <select
          class="form-control"
          style="background-color: #343A40; color: white; border-style: none;"
          #selectedLang
          (change)="switchLang(selectedLang.value)">
        <option *ngFor="let language of translate.getLangs()"
          [value]="language"
          [selected]="language === translate.currentLang">
          {{ language }}
        </option>
      </select>
    </span>
  </div>
  <div>
    <a class="navbar-brand" routerLinkActive="active" routerLink="/home">{{'siteTitle' | translate }}</a>
  </div>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
    (click)="collapsed = !this.collapsed">
    <span class="navbar-toggler-icon"></span>
  </button>
</nav>
